import request from '@utils/request'

export const state = {
  curationAlias:'',
}

export const mutations = {
  SET_ALIAS(state, value) {
    state.curationAlias = value
  },
}

export const actions = {
  /*
   * 取得目前主要策展
   * */
  getList({ commit, getters }) {
    return request
      .get(`/curation`)
      .then((response) => {
        commit('SET_ALIAS' , response.items.alias);
        return response.items;
      })
  },
  /*
   * 藉由別名取得策展
   * */
  getListWithAlias({ commit },{curationAlias}) {
    return request
      .get(`/curation/${curationAlias}`)
      .then((response) => {
        commit('SET_ALIAS' , response.items.alias);
        return response.items;
      })
  },
  /*
   * 取得目前主要策展下的主題
   * */
  getTopic({commit},{ curationAlias ,alias}){
    return request.get(`/curation/${curationAlias}/topic/${alias}`)
    .then((res) => res)
  }
}